var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yes-no-view"},[_c('div',{class:{ yes: true, active: _vm.value },on:{"click":function($event){return _vm.$emit('input', true)}}},[_vm._v("Ja")]),_c('div',{class:{ no: true, active: !_vm.value },on:{"click":function($event){return _vm.$emit('input', false)}}},[_vm._v("Nej")])])
}
var staticRenderFns = []

export { render, staticRenderFns }